import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSubscription } from '../Settings/SubscripitionChecker.jsx';
import { logout } from '../redux/authSlice';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jwtDecode } from 'jwt-decode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHouse,
    faBook,
    faUtensils,
    faCalendarAlt,
    faRightFromBracket
} from '@fortawesome/free-solid-svg-icons';

const ROLES = {
    HORECAMASTERS: 'HORECAMASTERS',
    BAAS: 'BAAS',
    FLOORMANAGER: 'FLOORMANAGER',
    HUMANRESOURCE: 'HUMANRESOURCE',
    MEDEWERKER: 'MEDEWERKER',
    KLOKSYSTEEM: 'KLOKSYSTEEM',
    CHEFKOK: 'CHEFKOK',
    AFWASSER: 'AFWASSER',
    KEUKENHULP: 'KEUKENHULP',
    SOUSCHEF: 'SOUSCHEF',
};

const menuItems = [
    { title: 'Dashboard', icon: faHouse, path: '/dashboard', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE, ROLES.CHEFKOK, ROLES.MEDEWERKER, ROLES.AFWASSER, ROLES.KEUKENHULP, ROLES.SOUSCHEF, ROLES.HORECAMASTERS] },
    { title: 'Reserveringen', icon: faBook, path: '/reserveringen', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.CHEFKOK, ROLES.SOUSCHEF, ROLES.HORECAMASTERS] },
    { title: 'Tafeltoewijzing', icon: faUtensils, path: '/tafeltoewijzing', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.SOUSCHEF, ROLES.HORECAMASTERS] },
    { title: 'Planbord', icon: faCalendarAlt, path: '/schedule', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE, ROLES.AFWASSER, ROLES.KEUKENHULP, ROLES.SOUSCHEF, ROLES.MEDEWERKER, ROLES.HORECAMASTERS] },
    { title: 'Logout', icon: faRightFromBracket, path: '/login', requiredRoles: [ROLES.BAAS, ROLES.FLOORMANAGER, ROLES.HUMANRESOURCE, ROLES.MEDEWERKER, ROLES.AFWASSER, ROLES.KEUKENHULP, ROLES.SOUSCHEF, ROLES.HORECAMASTERS] },
];

const Sidebar = () => {
    const dispatch = useDispatch();
    const [role, setRole] = useState('');
    const subscription = useSubscription();

    useEffect(() => {
        const fetchAuthInfo = () => {
            const token = sessionStorage.getItem('authToken');
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    const userRole = Array.isArray(decodedToken.roles) ? decodedToken.roles[0] : decodedToken.roles;
                    setRole(userRole);
                    localStorage.setItem('role', userRole);
                } catch (error) {
                    console.error('Error decoding token:', error);
                }
            } else {
                console.error('No auth token found');
            }
        };

        fetchAuthInfo();
    }, []);

    const handleLogout = () => {
        dispatch(logout());
        sessionStorage.removeItem('authToken');
        window.location.href = '/login';
    };

    const filteredMenuItems = menuItems.filter(item => item.requiredRoles.includes(role));

    return (
        <div
            className="vh-auto d-none d-md-flex"
            style={{
                backgroundColor: '#2C3E50',
                width: '60px',
                marginTop: '4px',
                overflow: 'visible',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '20px',
                padding: '20px 0',
            }}
        >
            {filteredMenuItems.map((item) => (
                <div
                    key={item.path}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '40px',
                    }}
                >
                    {item.title === 'Logout' ? (
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                handleLogout();
                            }}
                            title={item.title}
                            style={{
                                color: 'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                            }}
                        >
                            <FontAwesomeIcon icon={item.icon} style={{ fontSize: '1.4rem' }} />
                        </a>
                    ) : (
                        <Link
                            to={item.path}
                            title={item.title}
                            style={{
                                color: 'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                            }}
                        >
                            <FontAwesomeIcon icon={item.icon} style={{ fontSize: '1.4rem' }} />
                        </Link>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Sidebar;
